import { useTranslation } from "react-i18next";
import "./WhatsAppButton.css";

const PHONE = "553171926380";

export default function WhatsAppButton() {
  const { t } = useTranslation();
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(t("whatsapp.message"))}`;
  return (
    <a
      className="wa-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsapp.aria")}
    >
      <svg
        className="wa-btn__icon"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          fill="currentColor"
          d="M16.003 3C9.374 3 4 8.374 4 15.003c0 2.115.553 4.183 1.604 6.003L4 29l8.17-1.58a11.96 11.96 0 0 0 3.833.624h.004C22.636 28.044 28 22.67 28 16.04 28 12.83 26.75 9.82 24.48 7.55A12.01 12.01 0 0 0 16.003 3zm0 21.84a9.97 9.97 0 0 1-5.078-1.39l-.364-.216-4.85.938.97-4.73-.237-.377a9.96 9.96 0 0 1-1.53-5.313c0-5.514 4.486-10 10.088-10 2.696 0 5.23 1.052 7.134 2.957a10.01 10.01 0 0 1 2.953 7.129c0 5.514-4.486 10-10.086 10zm5.548-7.48c-.304-.152-1.8-.888-2.08-.99-.28-.104-.484-.152-.688.152-.202.304-.788.99-.966 1.192-.178.202-.356.228-.66.076-.304-.152-1.284-.473-2.446-1.51-.904-.806-1.514-1.802-1.692-2.106-.178-.304-.02-.468.133-.62.137-.136.304-.356.456-.534.152-.178.202-.304.304-.506.102-.202.05-.38-.025-.532-.076-.152-.688-1.66-.942-2.274-.248-.596-.5-.514-.688-.524l-.586-.01c-.202 0-.532.076-.81.38-.28.304-1.062 1.04-1.062 2.534s1.088 2.938 1.24 3.14c.152.202 2.138 3.266 5.18 4.578.723.312 1.287.498 1.727.638.726.23 1.387.198 1.91.12.583-.088 1.8-.736 2.054-1.446.254-.71.254-1.32.178-1.446-.076-.126-.28-.202-.584-.354z"
        />
      </svg>
    </a>
  );
}
